// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2Bas_","list":"PatternAutocomplete_list__312E1"};